// extracted by mini-css-extract-plugin
export default {"individualKey":"individualKey--BA94C","keyGroup":"keyGroup--s7ZC2"};